import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-inlusion-cgs',
  templateUrl: './inlusion-cgs.component.html',
  styleUrls: ['./inlusion-cgs.component.scss'],
})
export class InlusionCgsComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/inclusion/cgs/1.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/2.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/3.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/4.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/5.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/6.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/7.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/8.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/cgs/9.jpg',
      thumbnail: 'assets/img/school/inclusion/cgs/9.jpg',
      alt: 'Image 01',
    },
  ];
}
